import { attributeDefinitionIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const getAttributeValues = {
  name: "getAttributeValues" as const,
  input: z.object({
    definitionId: attributeDefinitionIdFormat.schema,
    search: z.string().optional(),
  }),
  output: z.object({ values: z.array(z.string()) }),
};
